import axios, { AxiosError } from 'axios';
import { deleteCookie, getCookie, setCookie } from 'cookies-next';
// import memoize from 'memoizee'
import { BASE_URL } from '@/utils/urlHelper';
import { COOKIE_KEYS } from '@/utils/constants';
export const client = axios.create({
  baseURL: BASE_URL + '/v1',
  headers: {
    'content-type': 'application/json'
  },
  timeout: 25000
});

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function isTokenExpired(token: string) {
  const decodedToken = JSON.parse(atob(token.split('.')[1]));
  return decodedToken.exp < Date.now() / 1000;
}
export const sendRefreshToken = async () => {
  const refresh_token = getCookie('refresh_token') ?? '';
  const res = await axios.post('/v1/auth/refresh_token', null, {
    headers: {
      Authorization: `Bearer ${refresh_token}`
    }
  }).catch(error => {
    if (error.response.status === 401) {
      deleteCookie('access_token');
      deleteCookie('refresh_token');
      window.location.href = '/'; // or login
    }
    return error;
  });
  const newToken = res?.data?.access_token ?? '';
  if (typeof window !== 'undefined' && newToken) {
    setCookie('access_token', newToken);
    setCookie('refresh_token', res.data?.refresh_token);
  }
  return newToken;
};
// const refreshToken = memoize(sendRefreshToken, {
//   promise: true,
//   maxAge: 5_000,
// })

client.interceptors.response.use(response => {
  return response;
}
// async function (error) {
//   const originalRequest = error.config
//   if (error?.response?.status === 401 && !originalRequest._retry) {
//     originalRequest._retry = true
//     const access_token = await refreshToken()
//     originalRequest.headers.Authorization = `Bearer ${access_token}`
//     return client(originalRequest)
//   }
//   return Promise.reject(error)
// },
);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const handleRequestFulfilled = async (config: any) => {
  let token = null;
  let fundraiserToken = null;
  if (typeof window === 'undefined') {
    const {
      cookies
    } = await import('next/headers');
    token = cookies().get('access_token')?.value || '';
    fundraiserToken = cookies().get(COOKIE_KEYS.fundraiser.access_token)?.value;
  } else {
    token = getCookie('access_token') ?? '';
    fundraiserToken = getCookie(COOKIE_KEYS.fundraiser.access_token);
  }
  if (config.url.startsWith('/sejam')) {
    config.baseURL = BASE_URL;
    config.timeout = 10_000;
  }
  if (config.url.includes('real-register')) {
    const registrationToken = getCookie('registration_token') ?? '';
    if (registrationToken) {
      config.headers.Authorization = `Bearer ${registrationToken}`;
    }
  }
  if (config.headers) {
    if (config.url.startsWith('/fundraisers') && fundraiserToken) {
      config.headers.Authorization = `Bearer ${fundraiserToken}`;
      if (config.data instanceof FormData) {
        config.timeout = 30_000;
      }
    } else if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  }

  // console.log('servers--config-url', config.url)
  // console.log('servers--config-headers', config.headers)

  return config;
};
const handleRequestRejected = (error: AxiosError): Promise<AxiosError> => {
  return Promise.reject(error);
};
client.interceptors.request.use(handleRequestFulfilled, handleRequestRejected);